import * as ActionType from '../ActionTypes';

export const SetUserEmail = (userEmail: string) => {
    return {
        type: ActionType.SET_USER_EMAIL,
        payload: userEmail
    };
}

export const SetUserObject = (userObject: {}) => {
    return {
        type: ActionType.SET_USER_OBJECT,
        payload: userObject
    }
}

export const SetUserAttributes = (userAttributes: {}) => {
    return {
        type: ActionType.SET_USER_ATTRIBUTES,
        payload: userAttributes
    }
}